import { Container, Grid } from "@mui/material";
import MeetingShow from "./MeetingShow";


const Meeting = () => {
  return (
    <>
      <Container sx={{ mt: 4 }} maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <MeetingShow />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Meeting;
